// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
import "./../../bindings/filtering";
import AppTabController from "../../services/app-tab-controller";

function CustomerPersonTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Customer = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.CustomFilter = ko.observableArray([]);
    self.CustomFilter.subscribe(function () {
        self.RefreshGrid();
    });
    self.PersonCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteCustomerPerson");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "CustomerPersonAdd":
                self.AddNewCustomerPerson();
                break;
            case "CustomerPersonAssign":
                self.ShowCustomerPersonDialog();
                break;
            case "CustomerPersonEdit":
                if (self.SelectedPersonRow() != null) {
                    self.ShowCustomerPersonTab(self.SelectedPersonRow());
                }
                break;
            case "CustomerPersonDelete":
                if (self.SelectedPersonRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteCustomerPerson(self.SelectedPersonRow().OpenData);
                        }
                    });
                }
                break;
        }
    };
    self.SelectedPersonId = ko.observable();
    self.SelectedPerson = ko.observable();
    self.SelectedPerson.subscribe(function () {
        self.AssignCustomerPerson(self.Customer.ConfigurationItemId(), self.SelectedPersonId());
    });
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetCustomerPersonCollection", JSON.stringify({
            customerId: self.Customer.ConfigurationItemId(),
            customFilter: self.ToHashObject(self.CustomFilter()),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedPersonRow(null);
            self.TotalRows(0);
            self.PersonCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.PersonCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddNewCustomerPerson = function () {
        var newTab = new TabPage("ConfigurationItem/Person");
        newTab.Url("ConfigurationItem/Person");
        newTab.IsClosable(true);
        newTab.EnableDirtyTracking(true);
        var o : any = {};
        o.Object.CustomerId = self.Customer.ConfigurationItemId();
        o.Object.CustomerName = self.Customer.Name1();
        o.Object.CountryId = self.Customer.CountryId();
        o.Object.CountryName = self.Customer.CountryName();
        newTab["Object"] = o;
        newTab.TabLoaded = function () { };
        AppTabController.AddTab(newTab);
    };
    self.AssignCustomerPerson = function (customerId, personId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AssignCustomerPerson", JSON.stringify({
            customerId: customerId,
            personId: personId
        }), function () {
            self.RefreshGrid();
        });
    };
    self.DeleteCustomerPerson = function (personId) {
        return Bao.post("ConfigurationItemTab/DeleteCustomerPerson", JSON.stringify({
            personId: personId
        }), function () {
            self.RefreshGrid();
        });
    };
    self.ShowCustomerPersonTab = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("ConfigurationItem/Person");
            newTab.UrlData({
                id: item.ConfigurationItemId
            });
            newTab.ObjectId(item.ConfigurationItemId);
            AppTabController.AddTab(newTab);
        }
    };
    self.ShowCustomerPersonDialog = function () { };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedPersonRow = ko.observable({});
    self.SelectedPersonRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button : any) {
            switch (button.ActionKey()) {
                case "CustomerPersonEdit":
                case "CustomerPersonDelete":
                    button.Enabled(!(self.SelectedPersonRow() == null));
                    break;
                case "CustomerPersonAdd":
                case "CustomerPersonAssign":
                    button.Enabled(!self.Customer.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        self.RefreshGrid().then(function () {
            def.resolve();
        });
        return def.promise();
    };
    self.Save = function () { };
    self.init = function () {
        return self.Refresh();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
}
;
export default CustomerPersonTabModel;